import React from "react";

function Footer(){
    return(
        <footer id="footer">
            <div>
                <h4>email</h4>
                <p><a href="mailto:rkddb1031@naver.com">rkddb1031@naver.com</a></p>
            </div>
            <div>
                <h4>Kakao</h4>
                <p><a href="/">@kxun_ii</a></p>
            </div>
            <div>
                <h4>social</h4>
                <ul>
                    <li><a href="https://www.instagram.com/kxun_ii">Instargram</a></li>
                    <li><a href="https://github.com/rkddbs1031">Github</a></li>
                    <li><a href="https://codepen.io/rkddbs1031">Codepen</a></li>
                    <li><a href="https://kxunii.tistory.com/">Tistory</a></li>
                    <li><a href="http://yoooon.dothome.co.kr/">Portfolio</a></li>
                    <li><a href="/">CSS</a></li>
                </ul>
            </div>
        </footer>
    )
}

export default Footer;